import React, { Component, Fragment } from 'react'
import Link from 'gatsby-link'

import logo from '../../../img/logo_prowedding_light.png'

import firebase from '../../../firebase'

class HeaderPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autenticato: false,
      loading: true
    }
  }

  autenticato(user) {
    if (user) {
      this.setState({
        autenticato: true,
        loading: false
      })
    } else {
      this.setState({
        autenticato: false,
        loading: false
      })
    }
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      this.autenticato(user)
    });
  }

  signOut() {
    const userId = firebase.auth().currentUser.uid;
    const ref = firebase.database().ref('account/' + userId);
    ref.update({
      loggato: 'offline'
    })

    firebase.auth().signOut()
      .then(function () {
        this.setState({
          autenticato: false
        })
      })
      .catch(function (error) {
        console.log(error)
      });

  }

  render() {

    return (
      <div className="uk-position-top">

        <nav className='pag uk-navbar-container uk-box-shadow-medium' data-uk-navbar data-uk-sticky="" >

          <div className="uk-navbar-left">

            <Link className="uk-navbar-item uk-logo" to="/" ><img src={logo} style={{ height: '40px' }} /></Link>

            <ul className="uk-navbar-nav">
                <li className="uk-visible@s"><Link to="/ricerca/" >Ricerca</Link></li>
                <li className="uk-hidden@s"><Link to="/ricerca/" ><span data-uk-icon="icon: search"></span></Link></li>
            </ul>
            
          </div>

          {!this.state.loading ?
          <div className="uk-navbar-right uk-visible@s">

            {this.state.autenticato ? (
              <ul className="uk-navbar-nav">
                <li><a onClick={this.signOut.bind(this)} >Logout</a></li>
                {this.props.pagina !== 'admin' ? <li><Link to="/admin/">Amministrazione</Link></li> : <Fragment />}
              </ul>
            ) : (
                <div className="uk-navbar-item"><Link to="/admin/" className="uk-button uk-button-default" >Area Riservata</Link></div>
              )
            }

          </div>
          :
          <div className="uk-navbar-right"></div>
          }

        </nav>

      </div>)
  }

}

export default HeaderPage



// WEBPACK FOOTER //
// ./src/components/header/headerpage/index.js